<template>
  <section ref="reservationCardRef" class="reservation card">
    <h3 class="title">{{ $t('begin_reserve') }}</h3>
    <reservation-date-time-picker v-model="bookingItem" :product="props.product" />
    <reservation-addition-and-upgrade
      v-if="bookingItem.length"
      v-model:additions="additions"
      v-model:upgrades="upgrades"
      class="mt-2"
      :product="props.product"
      :booking-item="bookingItem"
    />
    <reservation-summary class="mt-5" :product="props.product" :booking-item="bookingItem" :additions="additions" :upgrades="upgrades" />
  </section>
</template>

<script setup lang="ts">
import ReservationDateTimePicker from '@/components/reservation/reservation-date-time-picker.vue'
import ReservationAdditionAndUpgrade from '@/components/reservation/reservation-addition-and-upgrade.vue'
import ReservationSummary from '@/components/reservation/reservation-summary.vue'

import type { UiProductInfo, UiProductSelectedData } from '@/types/product'
import type { ProductUpgradeResource, ProductAdditionsResource } from '@/types/booking'

const FOOTER_BAR_ID = 'product-mobile-footer-bar'

const bookingItem = defineModel<UiProductSelectedData[]>('bookingItem', { default: [] })
const additions = defineModel<ProductAdditionsResource[]>('additions', { default: [] })
const upgrades = defineModel<ProductUpgradeResource[]>('upgrades', { default: [] })
const props = defineProps<{
  product: UiProductInfo
}>()

const reservationCardRef = ref<Nullable<HTMLElement>>(null)

onMounted(() => {
  const footerBar = document.getElementById(FOOTER_BAR_ID)
  if (!footerBar || !reservationCardRef.value) return
  useIntersectionObserver(
    reservationCardRef,
    entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          footerBar.classList.add('translate-y-full')
        } else {
          footerBar.classList.remove('translate-y-full')
        }
      })
    },
    { threshold: 0.1, rootMargin: '-144px 0px 0px 0px' }
  )
})
</script>

<style lang="scss" scoped></style>
